import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  padding: 16px;
  border: 1px solid ${Colors.GS500};
  cursor: pointer;
`

export const Inner = styled.div`
  display: grid;
  gap: 20px;
  justify-content: flex-start;
  grid-auto-flow: column;

  ${mediaQueries.tablet} {
    gap: 30px;
  }
`

export const Artwork = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  justify-self: center;

  ${mediaQueries.tablet} {
    width: 140px;
    height: 140px;
  }
`

export const Info = styled.div`
  display: grid;
  gap: 10px;
  justify-items: flex-start;
  align-content: center;
`

export const TitleContainer = styled.div`
  max-width: 100%;
  line-height: 1.5;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Title = styled.div`
  font-weight: 600;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Url = styled.div`
  max-width: 100%;

  margin-top: 4px;

  font-size: 14px;
  color: ${Colors.GS600};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
